/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit2_TInputs */

const en_to_xml_pit2_t = /** @type {(inputs: To_Xml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything becomes an element, never an attribute`)
};

const ko_to_xml_pit2_t = /** @type {(inputs: To_Xml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 것이 요소가 되며 속성이 되는 일은 없습니다`)
};

const ja_to_xml_pit2_t = /** @type {(inputs: To_Xml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてが要素になり、属性になることはありません`)
};

/**
* | output |
* | --- |
* | "Everything becomes an element, never an attribute" |
*
* @param {To_Xml_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit2_t = /** @type {((inputs?: To_Xml_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit2_t(inputs)
	if (locale === "ko") return ko_to_xml_pit2_t(inputs)
	return ja_to_xml_pit2_t(inputs)
});